
import React from 'react';

const StarUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M23.14 26c-.16 0-.33-.04-.48-.12l-6.67-3.64-6.66 3.64a.99.99 0 01-1.07-.07.982.982 0 01-.39-.99l1.4-7.47-5.53-5.22a1.001 1.001 0 01.56-1.72l7.54-.97 3.25-6.87c.17-.35.52-.57.91-.57s.74.22.9.57l3.25 6.87 7.54.97c.38.05.7.32.82.68.12.37.02.77-.26 1.04l-5.53 5.22 1.4 7.47a.993.993 0 01-.98 1.18zM16 20.09c.17 0 .33.04.48.12l5.3 2.89-1.11-5.93a1 1 0 01.3-.91l4.39-4.14-5.99-.77c-.34-.04-.63-.26-.78-.56l-2.58-5.45-2.6 5.45c-.14.31-.44.52-.77.56l-5.99.77 4.39 4.14a1 1 0 01.3.91l-1.11 5.93 5.3-2.89c.14-.07.3-.12.47-.12zM26.5 30h-21v2h21v-2z'
			></path>
		</svg>
	);
};

export default StarUnderline;
